const showcases = [
  {
    type: 'software',
    title: 'Digitale Auktionsplattform für internationale Auktionen',
    description: `Für <span class="underlined">Rippon Boswell & Co.</span> wurde eine bestehende Auktionsplattform schrittweise 
      modernisiert. Von der Migration einer legacybasierten 
      CRM-Anwendung über die Entwicklung einer React-basierten Website bis hin zur Live-Bidding-Anwendung 
      entstand eine moderne Lösung für Verwaltung, Veröffentlichung und digitale Durchführung <span class="underlined">internationaler Auktionen</span>.`,
    kpis: [
      { label: '3 Projektphasen' },
      { label: 'CRM-Migration' },
      { label: 'React-Plattform' },
      { label: 'Live-Bidding' },
      { label: 'zentrale Datenplattform' },
    ],
    link: '/software',
  },
  {
    type: 'software',
    title: 'Digitale Vermittlungsplattform für Transportunternehmen',
    description: `Für <span class="underlined">Entladehilfen</span> wurde eine individuelle Vermittlungsplattform für Transportunternehmen entwickelt. 
      Die Anwendung kombiniert Geolocation, Vermittlungs- und Abrechnungssystem sowie CMS- und Schnittstellenfunktionen 
      in einer zentralen Webplattform auf Basis von Meteor JS, React und MongoDB.`,
    kpis: [
      { label: 'CRM-/CMS-Funktionen' },
      { label: 'Geolocation-Integration' },
      { label: 'API-Schnittstellen' },
      { label: 'Drittanbindungen' },
    ],
    link: '/software',
  },
  {
    type: 'software',
    title: 'Performance\u00ADoptimierung einer Reporting-Plattform',
    description: `Optimierung einer datenintensiven Reporting-Plattform 
      mit Fokus auf Performance und PDF-Qualität. Durch Datenbankoptimierung, vektorbasierte Diagramme und die technische Verschlankung 
      des umliegenden WordPress-/WooCommerce-Systems konnten Generierungszeiten reduziert und die Darstellungsqualität der Reports 
      deutlich verbessert werden.`,
    kpis: [
      { label: 'optimierte PDF-Generierung' },
      { label: 'vektorbasierte Reports' },
      { label: 'Datenbankoptimierung' },
      { label: 'modulare Reportengine' },
    ],
    link: '/software',
  },
  {
    type: 'software',
    title: 'Zentralisierung interner Verwaltungsprozesse',
    description: `Entwicklung einer zentralen Verwaltungsplattform zur Ablösung verteilter Excel-Listen und Einzelsysteme. 
      Die Anwendung vereint unter anderem Wartungsmanagement, Zeiterfassung, Abrechnung, Monitoring, Angebotsverwaltung 
      und externe Systemanbindungen in einer zentralen Plattform mit LDAP-basierter Benutzerverwaltung.`,
    kpis: [
      { label: 'LDAP-Anbindung' },
      { label: 'API-Integrationen' },
      { label: 'zentrale Plattform' },
      { label: 'Prozessautomatisierung' },
    ],
    link: '/software',
  },
  {
    type: 'administration',
    title: 'Virtualisierung verteilter Webanwendungen',
    description: `Modernisierung einer verteilten Webanwendungs-Infrastruktur durch Migration auf eine 
      zentral verwaltete Virtualisierungsplattform mit Proxmox VE. Neben der Konsolidierung von Anwendungen, Datenbanken 
      und Storage wurden auch Monitoring, Proxy- und Mail-Infrastruktur zentralisiert und technisch vereinheitlicht.`,
    kpis: [
      { label: 'Proxmox VE' },
      { label: 'zentrale Datenhaltung' },
      { label: 'Zabbix Monitoring' },
      { label: 'Infrastruktur-Konsolidierung' },
    ],
    link: '/administration',
  },
  {
    type: 'administration',
    title: 'Serveradministration & Monitoring',
    description: `Für die <span class="underlined">SEG Wiesbaden mbH</span> und die <span class="underlined">WiBau GmbH</span> übernehmen wir die laufende Wartung und 
      Überwachung einer Windows/Linux-Serverinfrastruktur. Neben Monitoring mit Zabbix und Wazuh umfasst die 
      Betreuung auch Sicherheitsupdates, technische Beratung sowie regelmäßige Berichte mit Handlungsempfehlungen.`,
    kpis: [
      { label: '~20 Windows/Linux-Server' },
      { label: 'Sicherheitsmonitoring' },
      { label: 'monatliche Reports' },
      { label: 'laufende Systembetreuung' },
    ],
    link: '/administration',
  },
  {
    type: 'administration',
    title: 'Managed WLAN für 8 Studentenwohnheime',
    description: `Für acht Studentenwohnheime in Wiesbaden entwickelten wir eine zentral verwaltete 
      <span class="underlined"> WLAN- und Netzwerkstruktur</span> mit sicherer Fernwartung 
      und permanentem Monitoring. Das Ergebnis: weniger Ausfälle, schnellere Administration 
      und eine deutlich bessere Wartbarkeit im laufenden Betrieb.`,
    kpis: [
      { label: '8 Standorte' },
      { label: '200+ Zimmer' },
      { label: 'Zentrale Verwaltung' },
      { label: '24/7 Monitoring' },
    ],
    link: '/administration',
  },
];

export default showcases;
